import type { Event, EventReminder } from 'models';
import { Modal, type ModalOptions } from 'ui';
import { DuplicateReminderForm } from './duplicate-reminder-form';

export type DuplicateReminderModalOptions = {
  event: EventReminder;
};

type P = {
  onCancel: () => void;
  onSuccess: (eventData: Event) => void;
  options: ModalOptions<DuplicateReminderModalOptions>;
};

const DuplicateReminderModal = ({ onCancel, onSuccess, options }: P) => (
  <Modal isOpened={options.isOpened} onCancel={onCancel} title="Duplicate Reminder" width="large">
    {options.isOpened ? (
      <Modal.HugContent>
        <DuplicateReminderForm event={options.event} onCancel={onCancel} onSuccess={onSuccess} />
      </Modal.HugContent>
    ) : null}
  </Modal>
);

export default DuplicateReminderModal;
